import React from 'react';
import { Button } from '@mui/material';
import { buttonSelectedStyle, errorStyle, buttonStyle } from "./automations-helper";

type ValidationStatesMap = Record<string, Record<string, boolean | undefined> | undefined>;

type AutomationButtonProps = {
  componentName: string;
  index: number;
  option: string;
  label: React.ReactNode;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  validationStates: ValidationStatesMap;
  attemptedSubmission: boolean;
};

const AutomationButton = ({
  componentName,
  index,
  option,
  label,
  handleClick,
  validationStates,
  attemptedSubmission,
}: AutomationButtonProps) => {
  return (
    <Button 
      sx={{
        ...buttonStyle,
        ...(validationStates[`${componentName}_${index}`]?.[option] ? buttonSelectedStyle : {}),
        ...(attemptedSubmission && !validationStates[`${componentName}_${index}`]?.[option] ? errorStyle : {})
      }} 
      onClick={handleClick}
    >
      {label}
    </Button>
  );
};

export default AutomationButton;